<template>
  <div id="bookDetailsZh">
    <div class="bookDetailsZh">
      <div class="left_Title">
        <p>
          <i class="iconfont iconjieguo"></i>
          <span>详情</span>
        </p>
        <p></p>
      </div>
      <!--      详情-->
      <div class="book_brief">
        <div class="pdfButton" v-if="infosData&&infosData.annex>0"><img  @click="showSelectPdf"  src="@/assets/images/pdf.png"></div>
        <div class="left_brief">
          <div class="img_banner">
            <Carousel>
              <CarouselItem v-for="(item,index) in imgList" :key="index">
                <el-image
                    :src="item.images"
                    :preview-src-list="srcList">
                </el-image>
              </CarouselItem>
            </Carousel>
            <div v-if="infosData.annex>0" class="label">PDF</div>
          </div>
          <div class="books_info" v-if="infosData">
            <div class="title" v-if="infosData.namelang&&(infosData.namelang.zh||infosData.namelang.en)">
              <p>{{infosData.namelang.zh||infosData.namelang.en}}</p>
            </div>
            <div class="aqt_zhengzhuang">
              <p >ISBN: {{infosData.isbn ? infosData.isbn : '' }}</p>
            </div>
            <div class="aqt_zhengzhuang">
              <p class="press_name ">出版社 : <span class="pressName">{{infosData.presslang ? (infosData.presslang.zh||infosData.presslang.en) : '' }}</span></p>
            </div>
            <div class="aqt_zhengzhuang" v-if="infosData.authorlang&&(infosData.authorlang.zh||infosData.authorlang.en)">
              <p >作者 : {{infosData.authorlang.zh||infosData.authorlang.en}}
              </p>
            </div>
            <div class="aqt_zhengzhuang">
              <p >出版时间 : {{ infosData.publish_date ? infosData.publish_date : '' }}</p>
            </div>
            <div class="aqt_zhengzhuang">
              <p >页数: {{ infosData.page ? infosData.page : ''}}</p>
            </div>
            <div class="aqt_zhengzhuang">
              <p >字数: {{ infosData.word_count ? infosData.word_count : ''}}</p>
            </div>
            <div class="aqt_zhengzhuang">
              <p >价格: {{infosData.price ? infosData.price : ''}}</p>
            </div>
          </div>
        </div>
        <div class="right_brief" v-if="infosData.contentlang&&(infosData.contentlang.zh||infosData.contentlang.en)">
          <p>简介：</p>
          <p v-html="infosData.contentlang.zh||infosData.contentlang.en"></p>
        </div>
      </div>
      <!--      pdf-->
      <div class="book_pdflist" v-if="pdfList.length">
        <div class="_Title">
          <p>
            <i></i>
            <span >电子书</span>
          </p>
        </div>
        <div class="_pdflist">
          <div class="list__pdflist" @click="annexChange(item)" v-for="(item,index) in pdfList" :key="index">
            <p >
              {{ item.name ? item.name : ''}}
            </p>
            <p >{{ change(item.size) }}</p>
          </div>
        </div>
      </div>
      <!--      目录-->
      <div class="book_catalogue" v-if="catalogueList.length">
        <div class="_Title">
          <p>
            <i></i>
            <span >目录</span>
          </p>
        </div>
        <div class="_catalogue">
          <div class="list_catalogue" :style="{background:$crypto.get($route.query.directory_id)==item.directory_id?'rgba(0, 0, 0, 0.1)':'',color:$crypto.get($route.query.directory_id)==item.directory_id?'var(--themeColor)':''}" v-for="(item,index) in catalogueList" :key="index">
            <p  v-html="item.titlelang?(item.titlelang.zh||item.titlelang.en):''"></p>
            <p v-if="item.page" >({{ item.page ? item.page : '' }})</p>
          </div>
        </div>
      </div>
      <!--      有声书-->
      <div class="book_raudio" v-if="audioList.length">
        <div class="_Title">
          <p>
            <i></i>
            <span >有声书</span>
          </p>
        </div>
        <div class="_raudio">
          <div class="list_raudio" v-for="(item,index) in audioList" :key="index">
            <p  v-html="item.name?item.name:''"></p>
            <p >
              {{ item.voratime ? item.voratime : '00:00' }}
            </p>
            <p
                v-html="item.reader_name ? (item.reader_name.zh||item.reader_name.en):''"></p>
            <p >
              {{ item.size ? change(item.size) : '0' }}
            </p>
          </div>
        </div>
      </div>

      <!--    加载动画-->
<!--      <Spin v-if="isSpin" fix></Spin>-->
      <!--    加载动画-->
      <AqtSpin v-if="isSpin"></AqtSpin>
      <file_preview style="display:none" :file_name="url" ref="file_preview"></file_preview>
    </div>
  </div>
</template>
<script>
import store from "@/store";

export default {
  props: {
    infoId: {
      type: [String, Number],
      default: ''
    },
    directoryId:{
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isSpin: false,
      isSpin_press: false,
      imgList: [],
      srcList: [],
      audioList: [],
      pdfList: [],
      catalogueList: [],
      infosData: '',
      url: '',//pdf路径
      pressData: {
        name: '',//出版社名称
        address: '',//详细地址
        content: '',//出版社简介
        address_name: '',//地区
      },
    }
  },
  methods: {
    //  获取详情
    getbookDetails() {
      const _this = this;
      _this.isSpin = true
      let condition = {
        member_id: _this.member_id,
        book_id: _this.infoId,
        library_id: _this.library_id,

        terminal: _this.$terminal,
        wificode: _this.$store.getters.wificode,// Wi-Fi码
        network: _this.$store.getters.network,// 网络
        devicecode: _this.$store.getters.uuid,//设备码,
        latlon: _this.$store.getters.latlon,// 经纬度
      }
      _this.$httpsencrypt.post(`api/web/v3/book/findbook`, condition)
          .then((val) => {
            if (val.code == 200 && val.data) {
              _this.infosData = val.data
              // //轮播图
              _this.getIntors()
              //pdf
              // if (val.data.annex > 0) {
              //   _this.showSelectPdf()
              // }
              //目录
              _this.getCatalogue()
              //判断是否有音频
              _this.getIcon()


            } else {
              _this.isSpin = false
            }
          }).catch(e => {
        _this.isSpin = false
      })
    },
    //判断是否有音频
    getIcon() {
      let _this = this
      let cond = {
        book_id: _this.infoId,
      }
      _this.$httpsencrypt.post(`api/web/v3/book/isglother`, cond)
          .then((val) => {
            //isvideos 视频 0未关联 大于0已关联
            //isaudiojd 精读 0未关联 大于0已关联
            //isaudiojj 精讲 0未关联 大于0已关联

            if (val.code == 200) {
              //精讲
              if (val.data.isaudiojj > 0) {
                _this.getAydio()
              }
              //精读
              if (val.data.isaudiojd > 0) {

              }
            }

          })
    },
    //获取pdf
    showSelectPdf() {
      let that = this
      that.isSpin = true
      let condition = {
        model: 'Book',
        filetype: 'File',
        level: 'AQT_2023_1',
        id: that.infoId,
        type1: 1,
        name: '书籍详情pdf按钮',
      }
      that.pdfList = [];
      that.$getResources(condition).then(val => {
        if (val.code == 200) {
          that.pdfList = val.data.map((item) => {
            let bb = {
              type: item.type,
              url: item.url ? that.$webcrypto.get(item.url) : '',
              name: item.name,
              size: item.size,
              videopic: item.videopic,
              voratime: item.voratime,
              lx: item.lx,
              id: item.resources_id,
            }
            return bb;
          })
        } else {
          that.$Message.warning({
            render: h => {
              return h('span',{
                style: {
                  writingMode: 'vertical-lr'
                }
              },  val.message)
            }
          });
        }
        that.isSpin = false
      }).catch((err) => {
        that.isSpin = false
      });
    },
    //  获取目录
    getCatalogue() {
      const _this = this;
      let cond = {
        book_id: _this.infoId,
        type: 1,//1.书目录 2.期刊目录 3报刊 4普通论文
        member_id: _this.member_id,
        library_id: _this.library_id,
        terminal: _this.$terminal,

        wificode: _this.$store.getters.wificode,// Wi-Fi码
        network: _this.$store.getters.network,// 网络
        devicecode: _this.$store.getters.uuid,//设备码,
        latlon: _this.$store.getters.latlon,// 经纬度
      }
      _this.$httpsencrypt.post(`api/web/v3/directory/newindex`, cond)
          .then((val) => {
            _this.catalogueList = [];
            _this.handelSlugData(val.data, 0);
            _this.isSpin = false
          }).catch((err) => {
        _this.isSpin = false
        _this.catalogueList = [];
      });
    },
    //获取多图
    getIntors() {
      const _this = this
      _this.items = []
      let condition = {
        model: 'Book',
        filetype: 'Image',
        level: 'AQT_2023_2',
        id: _this.infoId,
        type1: 1,
        name: '书籍详情多图',
      }
      _this.$getResources(condition).then((val) => {
        if (_this.infosData.imgm) {
          _this.srcList.push(_this.$webcrypto.get(_this.infosData.imgm))
          let a = {
            images: _this.$webcrypto.get(_this.infosData.imgm)
          }
          _this.imgList.push(a)
        }

        if (val.code == 200 && val.data.length) {
          val.data.forEach(item => {
            let b = {
              images: _this.$webcrypto.get(item)
            }
            _this.imgList.push(b)
            _this.srcList.push(_this.$webcrypto.get(item))
          });
        }
      }).catch((err) => {
      });

    },
    //获取音频
    getAydio() {
      const _this = this;
      _this.audioList = []
      let cond = {
        read_type:1,
        book_id:_this.infoId,
        member_id: _this.member_id
      }
      _this.$httpsencrypt.post(`api/web/v3/audiobook/audiobookindex`, cond)
          .then((val) => {
            if (val.data.length) {
              _this.audioList=[]
              val.data.forEach(it=>{
                if(it.aulist.length){
                  it.aulist.forEach(kk=>{
                    _this.audioList.push({
                      ...kk,
                      ...it
                    })
                  })
                }
              })

            } else {
              _this.audioList = []
            }
          }).catch((err) => {
        _this.readList = []
        _this.audioList = []
      });
    },
    /************************************************************
     *
     * 处理数据格式
     *
     ************************************************************/
    handelSlugData(data, label) {
      const title = label
      data.map((el, ind) => {
        el.titlelang.zh = (el.titlelang.zh ? `<p  style="width:calc(100% - ${title}px);margin-left:${title}px;"> ${el.titlelang.zh}</p>` : `<p  style="width:calc(100% - ${title}px);margin-left:${title}px;"> ${el.titlelang.mn}</p>`)
        this.catalogueList.push(el)
        let label = title + 20
        if (el.child.length !== 0) this.handelSlugData(el.child, label)
      })
    },


    change(limit) {
      var size = "";
      if (limit < 0.1 * 1024) {                            //小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B"
      } else if (limit < 0.1 * 1024 * 1024) {            //小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB"
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {        //小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB"
      } else {                                            //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
      }

      var sizeStr = size + "";                        //转成字符串
      var index = sizeStr.indexOf(".");                    //获取小数点处的索引
      var dou = sizeStr.substr(index + 1, 2)            //获取小数点后两位的值
      if (dou == "00") {                                //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
      }
      return size;
    },
    //查看pdf
    annexChange(data) {
      this.url = data.url
      setTimeout(() => {
        this.$refs.file_preview.preview();
        this.saveUserBehavior(34,'书籍详情pdf资源查看',data.id)
      }, 500)
    },
    saveUserBehavior(type, mark, id) {
      let that = this
      let info = {
        book_id: id,
        magazine_id: null,
        type: type,
        path: this.$route.path,
        mark: mark,
      }
      that.$store.dispatch('saveUserBehavior', info).then(() => {
      })
    },
    //  显示出版社数据
    getPress(val, id) {
      let that = this
      that.$router.push(
          {
            path: '/BooksList',
            query: {
              lib_type:sessionStorage.getItem('gcm'),
              typeClass: that.$crypto.set(1),
              qActive: that.$crypto.set(4),
              searchContent: val ? that.$crypto.set(JSON.stringify(val)) : '',
              title_left: that.$crypto.set(JSON.stringify(that.$t('m.press'))),
              untype: '',
              press_id: id ? that.$crypto.set(id) : ''
            }
          }
      )
    },
  },
  created() {
    this.getbookDetails()
    let info={
      book_id: this.infoId,
      type: 1,
      path: this.$route.path,
      mark: '书籍详情',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ? JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : "";
      return vv
    },
    // 用户id
    member_id() {
      let mm = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return mm
    },
  }
}
</script>

<style lang="less" scoped>
#bookDetailsZh {
  width: 100%;
  height: 100%;

  .bookDetailsZh {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background: #ffffff;
    position: relative;

    .left_Title {
      min-height: 54px;
      width: 100%;
      background: #ffffff;
      margin-bottom: 2px;
      padding-right: 27px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      p:nth-child(1) {
        height: 24px;
        color: var(--themeColor);
        font-size: 20px;
        line-height: 24px;

        i {
          font-size: 24px;
        }
      }

      p:nth-child(2) {
        height: 4px;
        width: 162px;
        background: var(--themeColor);
        margin-top: 10px;
      }
    }

    ._Title {
      height: 30px;
      background: #ffffff;
      margin-bottom: 2px;
      padding-left: 35px;

      p:nth-child(1) {
        height: 27px;
        font-size: 20px;
        line-height: 27px;
        display: flex;

        i {
          display: block;
          height: 27px;
          width: 13px;
          background: var(--themeColor);
          margin-right: 14px;
        }

        span {
          color: var(--themeColor);
        }
      }
    }

    .book_brief {
      width: 100%;
      background: #ffffff;
      margin-bottom: 10px;
      padding: 10px 0;
      position: relative;
      .pdfButton{
        width: 50px;
        height: 50px;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 30px;
          height: auto;
          cursor: pointer;
        }
      }

      .left_brief {
        width: 100%;
        min-height: 180px;

        .img_banner {
          width: 270px;
          height: 180px;
          margin: 0 auto;
          position: relative;
          overflow: hidden;

          .label {
            line-height: 24px;
            height: 20px;
            height: 20px;
            background: red;
            color: #fff;
            font-size: 12px;
            position: absolute;
            right: 0;
            top: 0;
            z-index: 2;
            padding: 0 15px;
            -webkit-transform-origin: left bottom;
            -moz-transform-origin: left bottom;
            transform-origin: left bottom;
            -webkit-transform: translate(29.29%, -100%) rotate(45deg);
            -moz-transform: translate(29.29%, -100%) rotate(45deg);
            transform: translate(29.29%, -100%) rotate(45deg);
            text-indent: 0;
          }
        }

        .books_info {
          width: 100%;
          padding: 10px 20px 5px 20px;


          .title {
            width: 100%;
            height: 3.4rem;
            color: #333;
            font-size: 1.8rem;

            p {
              word-wrap: break-word;
              word-break: normal;
              width: 100%;
              line-height: 3.4rem;
            }
          }

          .aqt_zhengzhuang {
            width: 100%;
            min-height: 3.4rem;
            color: #888888;
            padding: 0 5px;
            display: flex;
            align-items: center;

            p {
              font-size: 1.6rem;
              word-wrap: break-word;
              word-break: normal;
              color: #888888;
              display: flex;
              line-height: 3.4rem;

              span {
                min-width: 20px;
                margin-right: 1px;

                img {
                  width: 1.5rem;
                  height: 1.5rem;
                  margin-right: 0.5rem;
                }
              }

            }

            p:nth-child(1) {
              min-width: 180px;
            }

            p:nth-child(2) {
              max-width: calc(100% - 180px);
            }
          }

          .press_name {
            cursor: pointer;
          }
          .pressName:hover{
            color: var(--themeColor);

          }

        }
      }

      .right_brief {
        min-height: 40px;
        width: 100%;
        color: #888888;
        font-size: 1.8rem;
        padding:0 25px;
        display: flex;
        p:nth-child(1){
          width: 65px;
        }
        p:last-child{
          width: calc(100% - 65px);
        }

        p {
          word-wrap: break-word;
          word-break: normal;
        }
      }
    }

    .book_catalogue {
      width: 100%;
      margin-bottom: 10px;

      ._catalogue {
        width: 100%;
        padding:10px 30px;
        background: #ffffff;

        .list_catalogue {
          //width: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin: 0 0.3rem;
          padding: 5px;
          display: flex;
          justify-content: space-between;
        }

        .list_catalogue:hover {
          background: rgba(0, 0, 0, 0.1);
          color: var(--themeColor);
        }
      }


    }

    .book_raudio {
      width: 100%;
      margin-bottom: 10px;

      ._raudio {
        width: 100%;
        padding: 10px 30px;
        background: #ffffff;

        .list_raudio {
          width: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin: 0.3rem 0;
          padding: 0 5px ;
          display: flex;

          p:nth-child(1) {
            width: 62%;
          }

          p:nth-child(2) {
            width: 10%;
            margin: 0 auto;
            color: #888888;
            text-align: center;
          }

          p:nth-child(3) {
            width: 15%;
            margin: 0 auto;
            color: #888888;
            text-align: center;
          }

          p:nth-child(4) {
            width: 13%;
            margin: 0 auto;
            color: #888888;
            text-align: center;
          }
        }
        .list_raudio:hover{
          background: rgba(0,0,0,0.1);
        }
      }
    }

    .book_pdflist {
      width: 100%;
      margin-bottom: 10px;

      ._pdflist {
        width: 100%;
        padding:17px 35px;
        background: #ffffff;

        .list__pdflist {
          width: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin:0.3rem 0;
          //background: #F2F7FF;
          background: #eeeeee;
          padding: 10px;
          cursor: pointer;
          display: flex;

          p:nth-child(1) {
            width: 85%;
          }

          p:nth-child(2) {
            width: 15%;
            text-align: center;
          }
        }

        .list__pdflist:hover {
          color: var(--themeColor);
        }
      }
    }
  }

  .bookDetailsZh::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 12px;
  }

  .bookDetailsZh::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .bookDetailsZh::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

}
</style>

<style lang="less">
#bookDetailsZh {
  .ivu-carousel {
    height: 100% !important;

    .ivu-carousel-list {
      height: 100% !important;

      .ivu-carousel-track {
        height: 100% !important;

        .ivu-carousel-item {
          height: 100% !important;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            border-radius: 10px;
            max-width: 270px !important;
            height: 180px;
          }
        }
      }
    }
  }

  .ivu-carousel-dots li button {
    opacity: unset !important;
    width: 5px !important;
    height: 5px !important;
    border-radius: 50%;
  }

  .ivu-carousel-dots li.ivu-carousel-active > button {
    opacity: unset !important;
    background: var(--themeColor);
  }

  .ivu-carousel-dots-inside {
    bottom: 15px !important;
  }

}
</style>
